import { KHFileInfo } from './kh-file-info';

/* istanbul ignore file */
export class ProjectNote {
    description: string;
    files: KHFileInfo[];
    id: string;
    name: string;
    projectId: string;
    text: string;
    type: string;
    richTextUpdatedText: string;
}
